import {createStore, applyMiddleware, compose} from 'redux'
import {Map} from 'immutable'
import thunk from 'redux-thunk'

import firedux from './firedux'

import notifications from './middlewares/notifications'

import rootReducer from './reducers/root'

// const store = applyMiddleware(thunk, notifications)(createStore)(rootReducer)
const store = createStore(
  rootReducer,
  Map({}),
  compose(
    applyMiddleware(thunk, notifications),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)

export const dispatch = store.dispatch
export const getState = store.getState

firedux.dispatch = dispatch

export default store



/** WEBPACK FOOTER **
 ** ./modules/shared/data/store.js
 **/